// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{width:100%;padding-top:6px;padding-bottom:6px;text-align:center;background-color:var(--background-color)}.banner.standard-banner,.banner.standard-banner a{background-color:var(--background-color)}.banner.accent-banner{padding-top:12px;padding-bottom:12px}.banner.accent-banner,.banner.accent-banner a{background-color:var(--coral-light);color:var(--accent-color)}.banner.information-banner{background-color:var(--information-color);color:white}.banner.success-banner{background-color:var(--success-color);color:white}.banner.warning-banner{background-color:var(--warning-color);color:white}.banner.error-banner{background-color:var(--error-color);color:white}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
